export default __webpack_public_path__ + "images/3232c56d99364fa53033135dd2a4a97a.png";